import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../../services/api";
import Menu from "../../comum/Menu";
import Footer from "../../comum/Footer";
import BarcodeModal from "../Components/BarcodeScanner";
import { Modal, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import "./auditoria.css";

function EstoqueMobileList({ dados }) {
    return (
        <div className="d-block d-md-none"> {/* Exibir APENAS no Mobile (tamanho menor que 'md') */}
            {dados.map((item, idx) => (
                <div key={idx} className="card mb-2 shadow-sm border">
                    <div className="card-body p-3">
                        <div className="d-flex justify-content-between align-items-start mb-2">
                            <h6 className="mb-0 text-primary">Loja: {String(item.loja).padStart(2, '0')}</h6>
                            
                            <span className={`badge center bg-${item.statuscompra === 'A' ? 'success' : 'danger'}`}>
                                {flagIcon(item.statuscompra)} Compra
                            </span>
                            
                            <span className={`badge center  bg-${item.statusvenda === 'A' ? 'success' : 'danger'}`}>
                                {flagIcon(item.statusvenda)} Venda
                            </span>
                        </div>
                        <div className="row small">
                            <div className="col-6">
                                <span className="text-muted">Estoque:</span>
                                <div className="fw-bold">{item.estoque}</div>
                            </div>
                            <div className="col-6 text-end">
                                <span className="text-muted">Custo:</span>
                                <div className="fw-bold">{formatarMoeda(item.custo)}</div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
/* ----------------- Helpers ----------------- */
function calcularDistancia(lat1, lon1, lat2, lon2) {
    const R = 6371;
    const dLat = (lat2 - lat1) * (Math.PI / 180);
    const dLon = (lon2 - lon1) * (Math.PI / 180);
    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * (Math.PI / 180)) *
        Math.cos(lat2 * (Math.PI / 180)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

const parseCurrencyToNumber = (v) => {
    if (v == null) return 0;
    if (typeof v === "number") return v;
    const s = String(v).replace(/\./g, "").replace(/,/g, ".");
    const n = parseFloat(s);
    return isNaN(n) ? 0 : n;
};

const formatarMoeda = (valor) => {
    if (valor == null || valor === "") return "";
    const numero = parseCurrencyToNumber(valor);
    return new Intl.NumberFormat("pt-BR", {
        style: "currency",
        currency: "BRL",
        minimumFractionDigits: 2,
    }).format(numero);
};

const formatarData = (data) => {
    if (!data) return "";
    if (typeof data === "string" && data.includes("/")) return data;
    const d = new Date(data);
    if (isNaN(d)) return data;
    const dia = String(d.getDate()).padStart(2, "0");
    const mes = String(d.getMonth() + 1).padStart(2, "0");
    const ano = d.getFullYear();
    return `${dia}/${mes}/${ano}`;
};

const flagIcon = (flag) => {
    const active = flag === "S" || flag === "A" || flag === true || flag === "T";
    return active ? (
        <i title="Ativo" className="fas fa-check-circle text-success me-1" />
    ) : (
        <i title="Inativo" className="fas fa-times-circle text-danger me-1" />
    );
};

/* ----------------- Loading ----------------- */
function LoadingModal({ show, message }) {
    if (!show) return null;
    return (
        <div className="loading-modal-overlay">
            <div className="loading-modal-content">
                <div
                    className="spinner-border text-primary"
                    role="status"
                    style={{ width: "3rem", height: "3rem" }}
                >
                    <span className="visually-hidden">Loading...</span>
                </div>
                <div style={{ marginTop: 12, fontSize: 16 }}>{message}</div>
            </div>

            <style>{`
        .loading-modal-overlay {
            position: fixed; top:0; left:0; 
            right:0; bottom:0;
            background: rgba(0,0,0,0.35);
            display:flex; align-items:center; justify-content:center; z-index:2000;
        }
        .loading-modal-content {
            background:white; padding:18px 28px; 
            border-radius:10px; text-align:center;
            box-shadow: 0 6px 20px rgba(0,0,0,0.18);
        }
      `}</style>
        </div>
    );
}

/* ----------------- Componente Principal ----------------- */
export default function AuditoriaProdutoV2() {
    const [pesquisa, setPesquisa] = useState("");
    const [produto, setProduto] = useState(null);
    const [showScanner, setShowScanner] = useState(false);
    const [loading, setLoading] = useState(false);
    const [loadingMessage, setLoadingMessage] = useState("");
    const [dadosEstoque, setDadosEstoque] = useState([]);
    const [showEstoqueModal, setShowEstoqueModal] = useState(false);
    const [isProcessingScan, setIsProcessingScan] = useState(false);
    const [lojaSelecionada, setLojaSelecionada] = useState(null);
    const [dentroDoRaio, setDentroDoRaio] = useState(false);
    const [ean, setEan] = useState(0);

    const navigate = useNavigate();
    const chapa = localStorage.getItem("chapa");
    const usuario = chapa;

    /* ----------------- Localização ----------------- */
    useEffect(() => {
        const permiteVendas = localStorage.getItem("permiteVendas");
        if (!chapa) {
            navigate("/arbor/login");
        } else if (permiteVendas !== "S") {
            Swal.fire({ icon: 'error', title: 'Acesso Negado', text: 'Não é permitido acessar o módulo de auditoria.', confirmButtonText: 'OK' })
                .then(() => navigate("/arbor/home"));
        }

        navigator.geolocation.getCurrentPosition(
            async (pos) => {
                try {
                    const { latitude, longitude } = pos.coords;
                    const resp = await api.get("lojas/localizacao");
                    const lojas = resp.data || [];

                    const lojaProxima = lojas.find((loja) => {
                        const distKm = calcularDistancia(
                            latitude,
                            longitude,
                            parseFloat(loja.latitude),
                            parseFloat(loja.longitude)
                        );
                        const distM = distKm * 1000;
                        return distM <= parseFloat(loja.distancia || 0);
                    });

                    if (lojaProxima) {
                        setLojaSelecionada(lojaProxima);
                        setDentroDoRaio(true);
                    } else {
                        Swal.fire(
                            "Atenção",
                            "Você não está dentro do raio de uma loja.",
                            "warning"
                        );
                        setDentroDoRaio(false);
                    }
                } catch (err) {
                    console.error(err);
                    setDentroDoRaio(false);
                }
            },
            (err) => {
                console.error(err);
                setDentroDoRaio(false);
            }
        );
    }, [chapa, navigate]);

    /* ----------------- Buscar Auditoria ----------------- */
    const buscarProdutoAuditoria = async (pesquisaParam = null) => {
        const codigo = pesquisaParam ?? pesquisa;
        if (!codigo || !lojaSelecionada) return;

        try {
            setLoading(true);
            setLoadingMessage("Buscando auditoria do produto...");
            setProduto(null);

            const loja = lojaSelecionada.cod_emp;
            const url = `AUDIT/pesquisa?loja=${loja}&pesquisa=${encodeURIComponent(
                codigo
            )}&usuario=${usuario}`;

            const resp = await api.get(url);
            const data = resp.data;
            setEan(pesquisa);

            if (!data || data.length === 0) {
                Swal.fire("Atenção", "Produto não encontrado.", "warning");
                return;
            }

            setProduto(data[0]);
            setPesquisa("");
        } catch (err) {
            console.error(err);
            Swal.fire("Erro", "Falha ao buscar produto.", "error");
        } finally {
            setLoading(false);
        }
    };

    /* ----------------- Estoque Outras Lojas ----------------- */
    const consultarEstoque = async () => {
        if (!produto || !lojaSelecionada) {
            Swal.fire("Atenção", "Nenhum produto selecionado.", "warning");
            return;
        }

        try {
            setLoading(true);
            setLoadingMessage("Consultando estoque...");

            const loja = 4;
            const url = `AUDIT/estoque?loja=${loja}&pesquisa=${produto.seqproduto}&usuario=${usuario}`;

            const resp = await api.get(url);
            const data = Array.isArray(resp.data) ? resp.data : [];

            setDadosEstoque(data);
            setShowEstoqueModal(true);
        } catch (err) {
            console.error(err);
            Swal.fire("Erro", "Erro ao consultar estoque.", "error");
        } finally {
            setLoading(false);
        }
    };

    /* ----------------- Imagem ----------------- */
    const getImagemSrc = (p) => {
        return `https://cdn-cosmos.bluesoft.com.br/products/${ean}`;
        console.log(ean);
    };

    return (
        <div className="d-flex flex-column min-vh-100">
            <Menu modulo="ARBOR" />

            <div className="container-fluid flex-grow-1 py-4">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-9">
                        <h3 className="mb-3 text-center">🔎 Auditoria de Produto</h3>

                        {/* Loja */}
                        <div className="mb-3">
                            <label className="fw-bold">Loja Localizada</label>
                            <input
                                className="form-control"
                                value={
                                    lojaSelecionada?.razao ||
                                    (dentroDoRaio ? "Carregando..." : "Não localizada")
                                }
                                readOnly
                            />
                        </div>

                        {/* Pesquisa */}
                        <div className="mb-4">
                            <label className="fw-bold"> EAN do produto</label>
                            <div className="input-group">
                                <input
                                    value={pesquisa}
                                    onChange={(e) => setPesquisa(e.target.value)}
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") buscarProdutoAuditoria();
                                    }}
                                    type="text"
                                    maxLength={50}
                                    placeholder="Digite ou escaneie"
                                    disabled={!dentroDoRaio || loading}
                                    className="form-control"
                                />

                                <button
                                    className="btn btn-primary"
                                    disabled={!dentroDoRaio || !pesquisa || loading}
                                    onClick={() => buscarProdutoAuditoria()}
                                >
                                    <i className="fas fa-search" />
                                </button>

                                <button
                                    className="btn btn-secondary"
                                    disabled={!dentroDoRaio || loading}
                                    onClick={() => setShowScanner(true)}
                                >
                                    <i className="fas fa-camera" />
                                </button>
                            </div>
                        </div>

                        {/* Produto */}
                        {produto ? (
                            <div className="card-bod product-card-body mb-4">
                                <div className="card-body product-card-body">
                                    <div className="product-header">
                                        <div className="product-image">
                                            <div className="img-box">
                                                <img
                                                    src={
                                                        getImagemSrc(produto) ||
                                                        "https://multilit.com.br/wp-content/uploads/2020/03/Produto-sem-foto.png"
                                                    }
                                                    alt={produto.desccompleta}
                                                    onError={(e) => {
                                                        e.target.onerror = null;
                                                        e.target.src =
                                                            "https://multilit.com.br/wp-content/uploads/2020/03/Produto-sem-foto.png";
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className="product-info">
                                            <h5 className="product-title">{produto.desccompleta}</h5>

                                            <div className="product-meta small text-muted">
                                                <strong>Código:</strong> {produto.seqproduto} &nbsp;|&nbsp;
                                                <strong>EAN:</strong> {ean || "N/A"} &nbsp;
                                            <br></br><strong>Família:</strong> {produto.familia+" ("+produto.seqfamilia+")"}
                                            </div>

                                            <div className="product-badges small">
                                                <span className="badge bg-light text-dark border">
                                                    <i className="fas fa-boxes me-1" />
                                                    {produto.multeqpembalagem} ({produto.qtdembalagem || 1})
                                                </span>
                                                <span className="badge bg-light text-dark border">
                                                    {flagIcon(produto.pesavel)} Pesável?
                                                </span>
                                                <span className="badge bg-light text-dark border">
                                                    {flagIcon(produto.pmtmultiplicacao)} Multiplica?
                                                </span>
                                                <span className="badge bg-light text-dark border">
                                                    {flagIcon(produto.statuscompra)} Ativo Compra
                                                </span>
                                                <span className="badge bg-light text-dark border">
                                                    {flagIcon(produto.statusvenda)} Ativo Venda
                                                </span>
                                                
                                            </div>

                                            <div className="small text-muted">
                                                <strong>Comprador:</strong>{" "}
                                                {produto.nomecomprador || "-"}
                                            </div>
                                        </div>
                                    </div>

                                    {/* Stats */}
                                    <div className="product-stats">
                                        <div className="stat">
                                            <div className="small text-muted">Tp Emb</div>
                                            <div className="fw-bold">
                                                {produto.multeqpembalagem ??
                                                    produto.multeqpemb ??
                                                    "-"}
                                            </div>
                                        </div>


                                        <div className="stat wide">
                                            <div className="small text-muted">Última Entrada</div>
                                            <div className="fw-bold">
                                                {formatarData(produto.ultima_entrada)}
                                            </div>
                                        </div>

                                        <div className="stat wide">
                                            <div className="small text-muted">Última Saída</div>
                                            <div className="fw-bold">
                                                {formatarData(produto.ultima_saida)}
                                            </div>
                                        </div>

                                        <div className="stat xwide">
                                            <div className="small text-muted">
                                                Última Movimentação
                                            </div>
                                            <div className="fw-bold">
                                                {formatarData(produto.ultima_movimentacao)}
                                            </div>
                                        </div>

                                        <div className="stat action">


                                            <div className="desktop-price mt-2 text-center d-none d-md-block">
                                                <span className="fw-bold" style={{ fontSize: 18 }}>
                                                    {formatarMoeda(
                                                        produto.precovalidnormal ||
                                                        produto.precobasenormal
                                                    )}
                                                </span>

                                                {produto.precovalidpromoc > 0 && (
                                                    <div className="text-danger larger fw-bold" style={{ fontSize: 18 }}>
                                                        Promoção:{" "}
                                                        {formatarMoeda(produto.precovalidpromoc)}
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div className="card mb-4">
                                <div className="card-body text-center text-muted py-5">
                                    <i className="fas fa-search fa-3x mb-3"></i>
                                    <div className="fw-bold">
                                        Pesquise um produto para iniciar
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* PREÇOS E DETALHES */}
                        {produto && (
                            <div className="row g-3">
                                {/* COLUNA 1 */}
                                <div className="col-12 col-md-6">
                                    <div className="card h-100 shadow-sm">
                                        <div className="card-body">
                                            <h6 className="card-title">📈 Preços & Validações</h6>

                                            <div className="small text-muted">Data Preço</div>
                                            <div className="fw-bold">
                                                {formatarData(produto.dtageracaopreco)}
                                            </div>

                                            <div className="mt-2 small text-muted">Custo</div>
                                            <div className="fw-bold">
                                                {formatarMoeda(produto.custo)}
                                            </div>

                                            <div className="mt-2 small text-muted">Preço Base</div>
                                            <div className="fw-bold">
                                                {formatarMoeda(
                                                    produto.precovalidnormal ||
                                                    produto.precobasenormal
                                                )}
                                            </div>

                                            {produto.iniciovarejo && (
                                                <>
                                                    <div className="mt-2 small text-muted">
                                                        Início Promoção
                                                    </div>
                                                    <div className="fw-bold">
                                                        {formatarData(produto.iniciovarejo)}
                                                    </div>
                                                </>
                                            )}

                                            {produto.fimvarejo && (
                                                <>
                                                    <div className="mt-2 small text-muted">
                                                        Fim Promoção
                                                    </div>
                                                    <div className="fw-bold">
                                                        {formatarData(produto.fimvarejo)}
                                                    </div>
                                                </>
                                            )}

                                            {produto.promovarejo > 0 && (
                                                <div className="mt-2 text-danger fw-bold">
                                                    Promoçao: {formatarMoeda(produto.promovarejo)}
                                                </div>
                                            )}

                                            {produto.inicioapp && (
                                                <>
                                                    <div className="mt-2 small text-muted">Início App</div>
                                                    <div className="fw-bold">
                                                        {formatarData(produto.inicioapp)}
                                                    </div>
                                                </>
                                            )}

                                            {produto.fimapp && (
                                                <>
                                                    <div className="mt-2 small text-muted">Fim App</div>
                                                    <div className="fw-bold">
                                                        {formatarData(produto.fimapp)}
                                                    </div>
                                                </>
                                            )}

                                            {produto.promoapp > 0 && (
                                                <div className="mt-2 text-danger fw-bold">
                                                    Preço App: {formatarMoeda(produto.promoapp)}
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>

                                {/* COLUNA 2 */}
                                <div className="col-12 col-md-6">
                                    <div className="card h-100 shadow-sm">
                                        <div className="card-body">
                                            <h6 className="card-title">📦 Estoques</h6>

                                            <div className="small text-muted">Estoque Loja</div>
                                            <div className="fw-bold">
                                                {produto.estqloja ?? 0} {produto.embalagem}
                                            </div>

                                            <div className="mt-2 small text-muted">Estoque CD</div>
                                            <div className="fw-bold">{produto.estqcd ?? 0}</div>

                                            <div className="mt-2 small text-muted">
                                                Estoque Depósito
                                            </div>
                                            <div className="fw-bold">
                                                {produto.estqdeposito ?? 0}
                                            </div>
                                            <div className="stat">
                                                <div className="small text-muted">Mín / Máx</div>
                                                <div className="fw-bold">
                                                    {produto.min ?? "-"} / {produto.max ?? "-"}
                                                </div>
                                            </div>

                                            <div className="mt-3">
                                                <Button
                                                    variant="outline-primary"
                                                    onClick={consultarEstoque}
                                                >
                                                    <i className="fas fa-list me-2" />
                                                    Ver Estoques Outras Lojas
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {/* Modal Estoque */}
            <Modal show={showEstoqueModal} onHide={() => setShowEstoqueModal(false)} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Estoque do produto: {produto?.desccompleta} em outras lojas.</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {dadosEstoque?.length > 0 ? (
                        <div style={{ maxHeight: "45vh", overflow: "auto" }}>
                            {/* 1. Visão de Tabela Padrão (Desktop/Tablet) */}
                            <div className="table-responsive d-none d-md-block"> {/* Ocultar no Mobile (d-none) */}
                                <table className="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th>Loja</th>
                                            <th className="text-end">Estoque</th>
                                            <th className="text-end">Custo</th>
                                            <th>Status Compra</th>
                                            <th>Status Venda</th>
                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {dadosEstoque.map((item, idx) => (
                                            <tr key={idx}>
                                                <td>{String(item.loja).padStart(2, '0')}</td>
                                                <td className="text-end">{item.estoque}</td>
                                                <td className="text-end">{formatarMoeda(item.custo)}</td>
                                                <td>{flagIcon(item.statuscompra)} {item.statuscompra}</td>
                                                <td>{flagIcon(item.statusvenda)} {item.statusvenda}</td>
                                                
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>

                            {/* 2. Visão Otimizada para Mobile (Card-like) */}
                            <EstoqueMobileList dados={dadosEstoque} />

                        </div>
                    ) : (
                        <div className="alert alert-warning text-center">Nenhum dado de estoque encontrado em outras lojas.</div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEstoqueModal(false)}>Fechar</Button>
                </Modal.Footer>
            </Modal>

            {/* SCANNER */}
            <BarcodeModal
                show={showScanner}
                onClose={() => setShowScanner(false)}
                onScanSuccess={(codigo) => {
                    if (isProcessingScan) return;

                    setIsProcessingScan(true);
                    setShowScanner(false);
                    setPesquisa(codigo);

                    buscarProdutoAuditoria(codigo).finally(() =>
                        setTimeout(() => setIsProcessingScan(false), 900)
                    );
                }}
            />

            <LoadingModal show={loading} message={loadingMessage} />




            <Footer />
        </div>
    );
}
